import { render } from "./SpvOptions.vue?vue&type=template&id=507d3f1d&scoped=true"
import script from "./SpvOptions.vue?vue&type=script&lang=js"
export * from "./SpvOptions.vue?vue&type=script&lang=js"

import "./SpvOptions.vue?vue&type=style&index=0&id=507d3f1d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507d3f1d"]])

export default __exports__